import React, { useState, useEffect } from 'react';
import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.es';
import LoadingGIF from '../assets/loading.gif';
import Descargar from '../assets/download.png';

import {
	getAllConversationsData,
	getAllNotUnderstandedMessagesStats,
	getAllSubjectsStats,
	getAllSubjects,
	downloadConversaciones,
	downloadNoEntendidos,
	downloadTemas,
} from '../../routing/routes';
import './ReportesEstilos.css';
import {
	PieChart,
	Pie,
	Sector,
	Cell,
	BarChart,
	Bar,
	Brush,
	ReferenceLine,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
} from 'recharts';

import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

const Reporteria = ({ permisos }) => {
	/* 
		fetched es una variable que indica que al menos la primera peticion de informacion fue hecha
		activeTab indica cual de todos los paneles se encuentran activos
		conversationsStats aloja toda la informacion relacionada al panel de conversaciones
		notUnderMessagesStats aloja toda la informacion relacionada al panel de mensajes no entendidos
		subjectStats aloja toda la informacion relacionada al panel de temas
	*/
	const [fetched, setFetched] = useState(null);
	const [activeTab, setActiveTab] = useState(0);
	const [conversationsStats, setConversationsStats] = useState(null);
	const [notUnderMessagesStats, setNotUnderMessagesStats] = useState(null);
	const [subjectStats, setSubjectStats] = useState(null);
	const [subjects, setSubjects] = useState(null);

	useEffect(() => {
		const startDate = new Date(new Date() - (new Date().getTimezoneOffset() / 60) * 1000 * 60 * 60);
		const endDate = new Date(new Date() - (new Date().getTimezoneOffset() / 60) * 1000 * 60 * 60);
		Promise.all([
			getAllConversationsData(startDate, endDate),
			getAllNotUnderstandedMessagesStats(startDate, endDate),
			getAllSubjectsStats(),
			getAllSubjects(),
		])
			.then((resultado) => {
				setConversationsStats(resultado[0]);
				setNotUnderMessagesStats(resultado[1]);
				setSubjectStats(resultado[2]);
				setSubjects(resultado[3]);
				setFetched(true);
			})
			.catch((error) => {
				setFetched(false);
			});
	}, []);
	/* 
        AQUI SE DEFINEN LAS OPCIONES QUE CONTENDRA EL MENU SUPERIOR
    */
	const opcionesMenu = ['Conversaciones', 'Mensajes no entendidos', 'Temas'];

	/* 
        AQUI SE DEFINE EL PANEL QUE SERA MOSTRADO DE ACUERDO AL MENU
    */

	const paneles = [PanelConversaciones, PanelMensajesNoEntendidos, PanelTemas];
	const PanelPrincipal = paneles[activeTab];

	/*
        AQUI REGRESA EL PANEL CORRESPONDIENTE SI ESTA CARGADA LA INFORMACION, SI NO, REGRESA LA LEYENDA DE "CARGANDO"
    */
	if (fetched === true) {
		return (
			<div>
				<Menu opcionesMenu={opcionesMenu} setActiveTab={setActiveTab} activeTab={activeTab} />
				<PanelPrincipal
					// Datos para el panel de conversaciones
					conversationsStats={conversationsStats}
					setConversationsStats={setConversationsStats}
					// Datos para el panel de mensajes no entendidos
					notUnderMessagesStats={notUnderMessagesStats}
					setNotUnderMessagesStats={setNotUnderMessagesStats}
					// Datos para el panel de temas
					subjectStats={subjectStats}
					subjects={subjects}
					permisos={permisos}
				/>
			</div>
		);
	} else if (fetched === false) {
		return (
			<div style={{ margin: '100px 0px' }}>
				<h3 style={{ textAlign: 'center' }}>ERROR</h3>
			</div>
		);
	} else {
		return (
			<div style={{ margin: '100px 0px' }}>
				<h3 style={{ textAlign: 'center' }}>CARGANDO...</h3>
				<div style={{ textAlign: 'center' }}>
					<span>
						<img style={{ height: '200px', width: '200px' }} src={LoadingGIF} alt={'Cargando'} />
					</span>
				</div>
			</div>
		);
	}
};

export default Reporteria;

const Menu = ({ opcionesMenu, setActiveTab, activeTab }) => {
	return (
		<div className='tabMenu'>
			{opcionesMenu.map((item, index) => (
				<div
					onClick={() => setActiveTab(index)}
					key={index}
					className={activeTab === index ? 'tabChild tabChild-selected' : 'tabChild'}>
					{item}
				</div>
			))}
		</div>
	);
};

//#region SECCION DESTINADA AL PANEL DE CONVERSACIONES

const PanelConversaciones = ({ conversationsStats, setConversationsStats, permisos }) => {
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(null);

	return (
		<div>
			<LeyendasConversaciones
				conversationsStats={conversationsStats}
				startDate={startDate}
				endDate={endDate}
				permisos={permisos}
			/>
			<Calendar
				language='es'
				enableRangeSelection={true}
				roundRangeLimits={true}
				onRangeSelected={(data) => {
					getAllConversationsData(data.startDate, data.endDate).then((stats) => {
						setStartDate(data.startDate);
						setEndDate(data.endDate);
						setConversationsStats(stats);
					});
				}}
				dataSource={[{ id: 0, startDate: startDate, endDate: endDate }]}
				style='background'
				enableContextMenu={true}
			/>
		</div>
	);
};

const LeyendasConversaciones = ({ conversationsStats, startDate, endDate, permisos }) => {
	const currentDate = toLongDateString(startDate, endDate);
	const complementaryString = startDate !== endDate && endDate !== null ? 'dentro del rango: ' : 'del día: ';

	return (
		<div>
			<div className='Reporteria-Leyenda-Container'>
				<span className='Reporteria-Leyenda'>Total conversaciones: {conversationsStats.conversacionesTotales}</span>

				<span className='Reporteria-Leyenda'>
					Total de derivaciones con agente: {conversationsStats.transferenciasTotales}
				</span>
			</div>

			<div className='Reporteria-Leyenda-Container'>
				<span className='Reporteria-Leyenda'>
					Conversaciones {complementaryString + conversationsStats.conversacionesPeriodo}
				</span>

				<span className='Reporteria-Leyenda'>
					Derivaciones {complementaryString + conversationsStats.transferenciasPeriodo}
				</span>
			</div>

			{permisos.descargarReportes && (
				<div style={{ textAlign: 'center', marginTop: '10px' }}>
					<span
						className='Reporteria-Descarga'
						onClick={() => {
							let from = undefined;
							let to = undefined;
							if (startDate !== undefined && startDate !== null && endDate !== undefined && endDate !== null) {
								from =
									startDate.getFullYear() +
									'-' +
									('00' + (startDate.getMonth() + 1)).slice(-2) +
									'-' +
									('00' + startDate.getDate()).slice(-2);
								to =
									endDate.getFullYear() +
									'-' +
									('00' + (endDate.getMonth() + 1)).slice(-2) +
									'-' +
									('00' + endDate.getDate()).slice(-2);
							}

							downloadConversaciones(from, to);
						}}>
						<p style={{ fontSize: '15px' }}>Descargar</p>
						<img style={{ height: '50px', width: '50px', marginTop: '-12px' }} src={Descargar} alt={'Descargar'} />
					</span>
				</div>
			)}

			<div className='Reporteria-Leyenda-Container'>
				<h3>{currentDate}</h3>
			</div>
		</div>
	);
};

//#endregion

//#region SECCION DESTINADA AL PANEL DE MENSAJES NO ENTENDIDOS

const PanelMensajesNoEntendidos = ({ notUnderMessagesStats, setNotUnderMessagesStats, permisos }) => {
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(null);

	return (
		<div>
			<LeyendasMensajesNoEntendidos
				notUnderMessagesStats={notUnderMessagesStats}
				startDate={startDate}
				endDate={endDate}
				permisos={permisos}
			/>
			<Calendar
				language='es'
				enableRangeSelection={true}
				roundRangeLimits={true}
				onRangeSelected={(data) => {
					getAllNotUnderstandedMessagesStats(data.startDate, data.endDate).then((stats) => {
						setStartDate(data.startDate);
						setEndDate(data.endDate);
						setNotUnderMessagesStats(stats);
					});
				}}
				dataSource={[{ id: 0, startDate: startDate, endDate: endDate }]}
				style='background'
				enableContextMenu={true}
			/>
		</div>
	);
};

const LeyendasMensajesNoEntendidos = ({ notUnderMessagesStats, startDate, endDate, permisos }) => {
	const currentDate = toLongDateString(startDate, endDate);
	const complementaryString = startDate !== endDate && endDate !== null ? 'dentro del rango: ' : 'del día: ';

	return (
		<div>
			<div className='Reporteria-Leyenda-Container' style={{}}>
				<span className='Reporteria-Leyenda'>Total de mensajes: {notUnderMessagesStats.mensajesTotales}</span>

				<span className='Reporteria-Leyenda'>
					Total de mensajes no entendidos: {notUnderMessagesStats.mensajesNoEntendidos}
				</span>
			</div>

			<div className='Reporteria-Leyenda-Container'>
				<span className='Reporteria-Leyenda'>Mensajes {complementaryString + notUnderMessagesStats.mensajesRango}</span>

				<span className='Reporteria-Leyenda'>
					Mensajes no entendidos {complementaryString + notUnderMessagesStats.mensajesNoEntendidosRango}
				</span>
			</div>

			{permisos.descargarReportes && (
				<div style={{ textAlign: 'center', marginTop: '10px' }}>
					<span
						className='Reporteria-Descarga'
						onClick={() => {
							let from = undefined;
							let to = undefined;
							if (startDate !== undefined && startDate !== null && endDate !== undefined && endDate !== null) {
								from =
									startDate.getFullYear() +
									'-' +
									('00' + (startDate.getMonth() + 1)).slice(-2) +
									'-' +
									('00' + startDate.getDate()).slice(-2);
								to =
									endDate.getFullYear() +
									'-' +
									('00' + (endDate.getMonth() + 1)).slice(-2) +
									'-' +
									('00' + endDate.getDate()).slice(-2);
							}

							downloadNoEntendidos(from, to);
						}}>
						<p style={{ fontSize: '15px' }}>Descargar</p>
						<img style={{ height: '50px', width: '50px', marginTop: '-12px' }} src={Descargar} alt={'Descargar'} />
					</span>
				</div>
			)}

			<div className='Reporteria-Leyenda-Container'>
				<h3>{currentDate}</h3>
			</div>
		</div>
	);
};

//#endregion

//#region SECCION DESTINADA AL PANEL DE TEMAS

const PanelTemas = ({ subjects, subjectStats, permisos }) => {
	return (
		<div style={{ textAlign: 'center', minWidth: '800px' }}>
			{permisos.descargarReportes && (
				<div style={{ textAlign: 'center', marginTop: '5px' }}>
					<span
						className='Reporteria-Descarga'
						onClick={() => {
							downloadTemas();
						}}>
						<p style={{ fontSize: '15px' }}>Descargar</p>
						<img style={{ height: '50px', width: '50px', marginTop: '-12px' }} src={Descargar} alt={'Descargar'} />
					</span>
				</div>
			)}
			{Object.keys(subjectStats).map((Canal, index) => {
				return <ContenedorTemas key={index} subjectStats={subjectStats[Canal]} Canal={Canal} />;
			})}
			<ContenedorComparativas subjectStats={subjectStats} subjects={subjects} />
		</div>
	);
};

const ContenedorComparativas = ({ subjects, subjectStats }) => {
	const COLORS = ['#0088FE', '#D19100', '#263646', '#00C49F', '#DEC90B', '#DE6C0B'];
	const [data, setData] = useState([]);
	useEffect(() => {
		const bars = [];
		for (let i = 0; i < subjects.length; i++) {
			const subject = subjects[i];
			const barObject = { name: subject };
			for (const canal in subjectStats) {
				if (subjectStats.hasOwnProperty(canal)) {
					const datosCanal = subjectStats[canal].Total;
					barObject[canal] = datosCanal[subject];
				}
			}
			bars.push(barObject);
		}
		setData(bars);
	}, [subjects, subjectStats]);

	if (data.length === 0) {
		return (
			<div className='Reporteria-ContenedorTemas'>
				<h1>NO HAY TEMAS REGISTRADOS</h1>
			</div>
		);
	} else {
		return (
			<div className='Reporteria-ContenedorTemas'>
				<div style={{ textAlign: 'center' }}>
					<h3 style={{ fontSize: '50px' }}>Canales</h3>
				</div>
				<BarChart
					style={{ margin: 'auto' }}
					width={750}
					height={600}
					data={data}
					margin={{
						top: 10,
						right: 35,
						left: 0,
						bottom: 100,
					}}>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis dataKey='name' />
					<YAxis />
					<Tooltip />
					<Legend verticalAlign='top' wrapperStyle={{ lineHeight: '40px' }} layout='vertical' iconType='diamond' />
					<ReferenceLine y={0} stroke='#000' />
					<Brush dataKey='name' height={30} stroke='#000000' width={500} x={125} />
					{Object.keys(subjectStats).map((canal, index) => {
						return <Bar dataKey={canal} fill={COLORS[index % COLORS.length]} key={canal} />;
					})}
				</BarChart>
			</div>
		);
	}
};

const ContenedorTemas = ({ subjectStats, Canal }) => {
	const [activeRecipient, setActiveRecipient] = useState(0);
	const data = [];
	const recipientes = Object.keys(subjectStats).filter((data) => data !== 'Total');
	recipientes.unshift('Total');

	Object.entries(subjectStats[recipientes[activeRecipient]]).map((entradas) => {
		return data.push({ name: entradas[0], value: entradas[1] });
	});

	return (
		<div className='Reporteria-ContenedorTemas'>
			{/* Aqui va el titulo de cada recuadro, en este caso, cada Canal */}
			<div style={{ textAlign: 'center' }}>
				<h3 style={{ fontSize: '50px' }}>{Canal}</h3>
			</div>

			{/* Aqui se dibuja la grafica de cada tema */}
			<Grafica data={data} />

			{/* Aqui van las estadisticas de cada Pagina */}
			<div className='Reporteria-ContenedorEstadisticas'>
				<h3 style={{ fontSize: '30px' }}>{recipientes[activeRecipient]} - Estadísticas</h3>
				{data.map((entradas, index) => {
					return <Indicador key={index} nombre={entradas.name} valor={entradas.value} />;
				})}
				<div>
					<Dropdown
						className='Reporteria-DropdownMenu'
						menuClassName='Reporteria-DropdownMenuPlaceHolder'
						options={recipientes}
						onChange={(data) => {
							setActiveRecipient(recipientes.findIndex((element) => element === data.value));
						}}
						value={recipientes[activeRecipient]}
						placeholder='Select an option'
					/>
				</div>
			</div>
		</div>
	);
};

const Indicador = ({ nombre, valor }) => {
	return (
		<span className='Reporteria-LeyendaEstadisticas'>
			Tema: {nombre}, Cantidad de consultas: {valor}
		</span>
	);
};

//#region REGION DE LAS GRAFICAS

const Grafica = ({ data }) => {
	const [index, setIndex] = useState(0);
	const COLORS = ['#263646', '#D19100', '#0088FE', '#00C49F', '#DEC90B', '#DE6C0B'];
	useEffect(() => {}, [data]);

	return (
		<PieChart width={550} height={350} style={{ display: 'inline' }}>
			<Pie
				activeIndex={index}
				activeShape={(data) => renderActiveShape({ ...data })}
				data={data}
				cx={270}
				cy={170}
				innerRadius={85}
				outerRadius={120}
				fill='#0069d1'
				dataKey='value'
				onMouseEnter={(value, index) => setIndex(index)}>
				{data.map((entry, index) => (
					<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
				))}
			</Pie>
		</PieChart>
	);
};

const renderActiveShape = (props) => {
	const RADIAN = Math.PI / 180;
	const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
	const sin = Math.sin(-RADIAN * midAngle);
	const cos = Math.cos(-RADIAN * midAngle);
	const sx = cx + (outerRadius + 10) * cos;
	const sy = cy + (outerRadius + 10) * sin;
	const mx = cx + (outerRadius + 30) * cos;
	const my = cy + (outerRadius + 30) * sin;
	const ex = mx + (cos >= 0 ? 1 : -1) * 22;
	const ey = my;
	const textAnchor = cos >= 0 ? 'start' : 'end';

	return (
		<g>
			<text x={cx} y={cy} dy={8} textAnchor='middle' fill='black'>
				{payload.name}
			</text>
			<Sector
				cx={cx}
				cy={cy}
				innerRadius={innerRadius}
				outerRadius={outerRadius}
				startAngle={startAngle}
				endAngle={endAngle}
				fill={fill}
			/>
			<Sector
				cx={cx}
				cy={cy}
				startAngle={startAngle}
				endAngle={endAngle}
				innerRadius={outerRadius + 6}
				outerRadius={outerRadius + 10}
				fill={fill}
			/>
			<path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill='none' />
			<circle cx={ex} cy={ey} r={2} fill={fill} stroke='none' />
			<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill='#333'>{`Cantidad: ${value}`}</text>
			<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill='#999'>
				{`(${(percent * 100).toFixed(2)}%)`}
			</text>
		</g>
	);
};

//#endregion

//#endregion

//#region REGION DE FUNCIONES GENERALES

function toLongDateString(startDate = new Date(), endDate = null) {
	const meses = [
		'Enero',
		'Febrero',
		'Marzo',
		'Abril',
		'Mayo',
		'Junio',
		'Julio',
		'Agosto',
		'Septiembre',
		'Octubre',
		'Noviembre',
		'Diciembre',
	];

	if (!endDate || startDate === endDate) {
		return startDate.getDate() + ' de ' + meses[startDate.getMonth()] + ' del ' + startDate.getFullYear();
	} else {
		return (
			startDate.getDate() +
			' de ' +
			meses[startDate.getMonth()] +
			' del ' +
			startDate.getFullYear() +
			'    al    ' +
			endDate.getDate() +
			' de ' +
			meses[endDate.getMonth()] +
			' del ' +
			endDate.getFullYear()
		);
	}
}

//#endregion
